// extracted by mini-css-extract-plugin
export var footer = "_s4-0";
export var inherit = "_s4-1";
export var input = "_s4-2";
export var modalContent = "_s4-3";
export var quillEditor = "_s4-4";
export var subtitle = "_s4-5";